import React from 'react';

import RawInput from './raw_input';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { Value } from './types';

interface Props {
  bracketizeNames?: boolean;
  customFields: CustomField[],
  inputNamePrefix?: string;
  valuesByName?: Record<string, Value>;
}

export default function ApexCustomFieldRawInputs({
  bracketizeNames = false,
  customFields,
  inputNamePrefix = '',
  valuesByName = {},
}: Props) {
  return <>
    {customFields.map(customField => (
      <RawInput
        bracketizeName={bracketizeNames}
        customField={customField}
        inputNamePrefix={inputNamePrefix}
        key={customField.name}
        value={valuesByName[customField.name]}
      />
    ))}
  </>;
}
